export interface ApprovalActionConfig {
  disallowRejectRoles?: string[];
  disallowEditRoles?: string[];
  disallowApprovalActionsRoles?: string[];
  hiddenStatuses?: string[];
}

export const approvalActionConfig: ApprovalActionConfig = {
  disallowRejectRoles: ['CC_EMPLOYEE', 'FUEL_ADMIN', 'CEO_ASSISTANT'],
  disallowEditRoles: ['CC_EMPLOYEE', 'FUEL_ADMIN'],
  disallowApprovalActionsRoles: ['CC_EMPLOYEE', 'FUEL_ADMIN', 'CEO_ASSISTANT'],
  hiddenStatuses: ['draft', 'returned_back', 'finished', 'cancelled', 'approved', 'declined'],
};

export function canPerformApprovalAction(
  action: 'reject' | 'edit',
  roles: readonly string[] | undefined | null
): boolean {
  if (!roles || roles.length === 0) {
    return true;
  }

  const normalizeRole = (role: string) =>
    role
      .trim()
      .toUpperCase()
      .replace(/^ROLE_/, '');

  const normalizedRoles = roles
    .filter((role): role is string => typeof role === 'string' && role.trim().length > 0)
    .map(normalizeRole);

  const disallowedRoles =
    action === 'reject'
      ? approvalActionConfig.disallowRejectRoles
      : approvalActionConfig.disallowEditRoles;

  if (!disallowedRoles || disallowedRoles.length === 0) {
    return true;
  }

  const normalizedDisallowed = disallowedRoles
    .filter((role): role is string => typeof role === 'string' && role.trim().length > 0)
    .map(normalizeRole);

  return !normalizedRoles.some((role) => normalizedDisallowed.includes(role));
}

export function isApprovalActionVisibleForStatus(status: string): boolean {
  const hiddenStatuses = approvalActionConfig.hiddenStatuses;
  if (!hiddenStatuses || hiddenStatuses.length === 0) {
    return true;
  }

  return !hiddenStatuses.includes(status);
}

export function canShowApprovalActions(roles: readonly string[] | undefined | null): boolean {
  if (!roles || roles.length === 0) {
    return true;
  }

  const normalizeRole = (role: string) =>
    role
      .trim()
      .toUpperCase()
      .replace(/^ROLE_/, '');

  const normalizedRoles = roles
    .filter((role): role is string => typeof role === 'string' && role.trim().length > 0)
    .map(normalizeRole);

  const disallowedRoles = approvalActionConfig.disallowApprovalActionsRoles;

  if (!disallowedRoles || disallowedRoles.length === 0) {
    return true;
  }

  const normalizedDisallowed = disallowedRoles
    .filter((role): role is string => typeof role === 'string' && role.trim().length > 0)
    .map(normalizeRole);

  return !normalizedRoles.some((role) => normalizedDisallowed.includes(role));
}
